import ApiService from "./ApiService";

export async function apiGetPartners (params) {
    const { query } = params
    return ApiService.fetchData({
        url: query,
        method: 'get',
        //params
    })
}

export async function apiPostPartners (data) {
    return ApiService.fetchData({
        url: `/partners`,
        method: 'post',
        data
    })
}

export async function apiPutPartners (id, data) {
    return ApiService.fetchData({
        url: `/partners/${id}`,
        method: 'put',
        data
    })
}

export async function apiDeletePartners (id) {
    return ApiService.fetchData({
        url: `/partners/${id}`,
        method: 'delete',
    })
}
